export enum clientTypeEnum {
  litigation = 'litigation',
  financial = 'financial',
  trial = 'trial',
  developer = 'developer',
}
